// Immunizations subsection form field enum
export enum ImmunizationsFormField {
  IMMUNIZATIONS_HEP_B = 'medical-background/immunizations/hep-b/hep-b',
  IMMUNIZATIONS_HEP_B_DATE = 'medical-background/immunizations/hep-b/date',
  IMMUNIZATIONS_MENINGOCOCCAL = 'medical-background/immunizations/meningococcal/meningococcal',
  IMMUNIZATIONS_MENINGOCOCCAL_DATE = 'medical-background/immunizations/meningococcal/date',
  IMMUNIZATIONS_COVID_19 = 'medical-background/immunizations/covid-19/covid-19',
  IMMUNIZATIONS_COVID_19_DATE = 'medical-background/immunizations/covid-19/date',
  IMMUNIZATIONS_DTAP = 'medical-background/immunizations/dtap/dtap',
  IMMUNIZATIONS_DTAP_DATE = 'medical-background/immunizations/dtap/date',
  IMMUNIZATIONS_HPV = 'medical-background/immunizations/hpv/hpv',
  IMMUNIZATIONS_HPV_DATE = 'medical-background/immunizations/hpv/date',
  IMMUNIZATIONS_RSV = 'medical-background/immunizations/rsv/rsv',
  IMMUNIZATIONS_RSV_DATE = 'medical-background/immunizations/rsv/date',
  IMMUNIZATIONS_NOTES = 'medical-background/immunizations/notes'
}
